import React from 'react'
import { Link } from 'react-router-dom'
import { Phone, Mail, MapPin, ShieldCheck } from 'lucide-react'

export default function Footer() {
  return (
    <footer className="bg-neutral-950 border-t border-neutral-800 text-neutral-400">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12">
          {/* Virksomhedsinfo */}
          <div className="space-y-4">
            <div className="flex items-center gap-3">
              <img 
                src="https://assets.auxodev.dk/assets/4eef1727-4c51-4dbe-8773-4e974f33a84d/6fc95741-bbf3-49e6-9c69-766b0204a25f.png" 
                alt="D&W Udlejning ApS Logo" 
                className="h-12 w-auto object-contain bg-white p-1.5 rounded-md"
              />
            </div>
            <p className="text-sm leading-relaxed text-neutral-400 max-w-sm">
              Din lokale og pålidelige partner i Skibby og omegn. Vi udlejer mindre, driftssikre entreprenørmaskiner til både private og erhverv med fokus på høj kvalitet og fleksibel service.
            </p>
            <div className="text-xs text-neutral-500 font-semibold">
              CVR-nr: 46378458
            </div>
          </div>

          {/* Hurtige Links */}
          <div className="space-y-4">
            <h4 className="text-sm font-bold text-white uppercase tracking-wider border-b border-neutral-800 pb-2">
              Hurtige links
            </h4>
            <ul className="space-y-2.5 text-sm">
              <li>
                <Link to="/" className="hover:text-amber-500 transition-colors duration-200 font-medium">
                  Forside
                </Link>
              </li>
              <li>
                <Link to="/udlejning" className="hover:text-amber-500 transition-colors duration-200 font-medium">
                  Udlejning af entreprenørmaskiner
                </Link>
              </li>
              <li>
                <Link to="/vaerktojsudlejning" className="hover:text-amber-500 transition-colors duration-200 font-medium">
                  Udlejning af værktøj
                </Link>
              </li>
              <li>
                <Link to="/kontakt" className="hover:text-amber-500 transition-colors duration-200 font-medium">
                  Kontakt os
                </Link>
              </li>
            </ul>
          </div>

          {/* Kontaktoplysninger */}
          <div className="space-y-4">
            <h4 className="text-sm font-bold text-white uppercase tracking-wider border-b border-neutral-800 pb-2">
              Kontaktoplysninger
            </h4>
            <ul className="space-y-3.5 text-sm">
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-amber-500 shrink-0 mt-0.5" />
                <div>
                  <p className="font-bold text-white">D&W Udlejning ApS</p>
                  <p>Nyvej 9</p>
                  <p>4050 Skibby</p>
                </div>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="w-5 h-5 text-amber-500 shrink-0" />
                <a href="tel:20828970" className="hover:text-amber-500 transition-colors duration-200 font-bold text-white whitespace-nowrap">
                  20 82 89 70
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="w-5 h-5 text-amber-500 shrink-0" />
                <a href="mailto:dw@dw-udlejning.dk" className="hover:text-amber-500 transition-colors duration-200 font-bold text-white whitespace-nowrap">
                  dw@dw-udlejning.dk
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bund-bar */}
        <div className="mt-12 pt-8 border-t border-neutral-900 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-neutral-500 font-medium">
          <p>© {new Date().getFullYear()} D&W Udlejning ApS. Alle rettigheder forbeholdes.</p>
          <div className="flex items-center gap-1.5">
            <ShieldCheck className="w-4 h-4 text-amber-500" />
            <span>Professionel maskinudlejning i Skibby</span>
          </div>
        </div>
      </div>
    </footer>
  )
}
